import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import shopControlsVisibilities from 'apps/header/utils/shopControlsVisibilities';
import { wa } from 'apps/analytics';
import PageEvents from 'apps/header/models/PageEvents';

import InstantShop from '../containers/InstantShop';
import MobileSidebar from 'widgets/MobileSidebar/MobileSidebar';
import RemoveAllConfirm from './RemoveAllConfirm';
import ShoppingLists from '../containers/ShoppingListsContainer';
import TrolleyMenuFooter from '../containers/TrolleyMenuFooter';
import TrolleyMenuHeaderContainer from '../containers/TrolleyMenuHeader';
import TrolleyMenuItems from './TrolleyMenuItems';

export default class TrolleyMenu extends Component {
  static propTypes = {
    basket: PropTypes.shape({
      numberOfItems: PropTypes.number,
    }).isRequired,
    betaFeatures: PropTypes.array.isRequired,
    closeTrolleyMenu: PropTypes.func.isRequired,
    deliverySlot: PropTypes.object,
    ensureBasketProducts: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onRemoveAll: PropTypes.func.isRequired,
    onRemoveAllCancel: PropTypes.func.isRequired,
    onRemoveAllConfirm: PropTypes.func.isRequired,
    productsBySku: PropTypes.object.isRequired,
    removeAllConfirmOpened: PropTypes.bool,
    shopControlsVisibility: PropTypes.string.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    if (!nextProps.isOpen && !this.props.isOpen) {
      return false;
    }

    return (
      this.props.isOpen !== nextProps.isOpen
      || this.props.basket !== nextProps.basket
      || this.props.deliverySlot !== nextProps.deliverySlot
      || this.props.productsBySku !== nextProps.productsBySku
      || this.props.removeAllConfirmOpened !== nextProps.removeAllConfirmOpened
    );
  }

  UNSAFE_componentWillUpdate() {
    this.props.ensureBasketProducts();
  }

  onCloseSidebarMenu = () => {
    const { closeTrolleyMenu } = this.props;
    wa.triggerPageEventWithDescription(PageEvents.CLOSE_MOBILE_TROLLEY_MENU);
    closeTrolleyMenu();
  };

  render() {
    const {
      basket,
      betaFeatures,
      deliverySlot,
      isOpen,
      onRemoveAll,
      onRemoveAllCancel,
      onRemoveAllConfirm,
      removeAllConfirmOpened,
      shopControlsVisibility,
    } = this.props;
    const shouldDisplayAddToList = (betaFeatures.includes('RESPONSIVE_SHOPPING_LISTS') && basket.numberOfItems > 0);

    return (
      <Fragment>
        <MobileSidebar
          isOpen={isOpen}
          position="right"
          onClose={this.onCloseSidebarMenu}
        >
          <div className={classNames('hd-trolleyMenu', {
            'hd-trolleyMenu--withoutShopControls': shopControlsVisibilities.NONE === shopControlsVisibility,
            'hd-trolleyMenu--withoutCheckout': shopControlsVisibilities.SLOT_BOOKING_ONLY === shopControlsVisibility,
          })}
          >
            <TrolleyMenuHeaderContainer
              basket={basket}
              deliverySlot={deliverySlot}
            />
            <InstantShop />
            <div className="hd-trolleyMenu__content">
              <TrolleyMenuItems
                basket={basket}
                onRemoveAll={onRemoveAll}
              />
              <TrolleyMenuFooter
                checkoutAllowed={basket.checkoutAllowed}
                deliverySlot={deliverySlot}
                shouldDisplayAddToList={shouldDisplayAddToList}
              />
            </div>
          </div>
        </MobileSidebar>
        <RemoveAllConfirm
          removeAllConfirmOpened={removeAllConfirmOpened}
          onRemoveAllCancel={onRemoveAllCancel}
          onRemoveAllConfirm={onRemoveAllConfirm}
        />
        <ShoppingLists />
      </Fragment>
    );
  }
}
